// @flow

import React, { Component } from "react";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";

import LiveSource from "../LiveSource/LiveSource";

const styles = theme => {
  return {
    card: {
      marginBottom: theme.spacing.unit * 2,
      display: "flex"
    },
    actions: {
      display: "flex",
      flexDirection: "column",
      flex: "auto",
      justifyContent: "flex-end"
    },
    streamImage: {
      width: "75%",
      height: "100%"
    },
    buttonGroup: {
      overflowY: "overlay"
    },
    loadingIndicator: {
      margin: theme.spacing.unit
    },
    injectButton: {
      margin: theme.spacing.unit
    }
  };
};

type Props = {
  clickedHandler: (duration: number) => void,
  videoElementMounted: (el: HTMLVideoElement) => void,
  classes: any,
  loading: boolean,
  useImage: boolean
};

class AdInjectComponent extends Component<Props, {}> {
  videoElement: React.Ref<HTMLVideoElement>;

  constructor(props) {
    super(props);
    this.videoElement = React.createRef();
  }

  componentDidMount() {
    if (this.videoElement.current) {
      this.props.videoElementMounted(this.videoElement.current);
    }
  }

  render() {
    const { classes } = this.props;
    const props = this.props;

    return (
      <Card className={classes.card}>
        {this.props.useImage ? (
          <img
            alt=""
            id="imageCanvas"
            src=""
            component="img"
            className={classes.streamImage}
          />
        ) : (
          <LiveSource videoElementRef={this.videoElement} />
        )}

        <CardActions className={classes.actions}>
          {props.loading ? (
            <CircularProgress className={classes.loadingIndicator} />
          ) : null}

          <Button
            variant="raised"
            disabled={props.loading}
            className={classes.injectButton}
            onClick={() => props.clickedHandler(30000)}
          >
            30 sec
          </Button>

          <Button
            variant="raised"
            disabled={props.loading}
            className={classes.injectButton}
            onClick={() => props.clickedHandler(35000)}
          >
            35 sec
          </Button>
        </CardActions>
      </Card>
    );
  }
}

export default withStyles(styles)(AdInjectComponent);



// WEBPACK FOOTER //
// ./src/AdInject/Component.js